import Moment from 'moment';
import { extendMoment } from 'moment-range';
import 'moment/locale/es';

const moment = extendMoment(Moment);

moment.locale('es');
let startDate = moment().startOf('week').format('D');
let endDate = moment().endOf('week').format('D [de] MMMM [del] YYYY');

let weekStart = moment().startOf('week');
let weekDays = [];
let weekDays2 = [];
for (let i = 0; i <= 6; i++) {
  weekDays.push(moment(weekStart).add(i, 'days').format('ddd D'));
  weekDays2.push(moment(weekStart).add(i, 'days').format('D'));
}


function getMonthWeeks(month) {
  let startMonth =
    month === 'month'
      ? moment().startOf('month')
      : moment().month(month).startOf('month');
  let endMonth =
    month === 'month'
      ? moment().endOf('month')
      : moment().month(month).endOf('month');
  /*Get start and end of other month let startMonth = moment([2020,1]).startOf('month');*/

  let monthRange = moment.range(startMonth, endMonth);
  let monthWeeks = Array.from(monthRange.by('week'));
  //console.log('mes actual', moment().month())

  return monthWeeks;
}

export function getWeekRanges(month) {
  let startMonth =
    month === 'month'
      ? moment().startOf('month')
      : moment().month(month).startOf('month');
  let endMonth =
    month === 'month'
      ? moment().endOf('month')
      : moment().month(month).endOf('month');
  /*Get start and end of other month let startMonth = moment([2020,1]).startOf('month');*/

  let monthRange = moment.range(startMonth, endMonth);
  let monthWeeks = Array.from(monthRange.by('week'));

  let weekRanges = [];
  for (let i = 0; i < monthWeeks.length - 1; i++) {
    if (i == monthWeeks.length - 2) {
      weekRanges.push(
        `Del ${moment(monthWeeks[i]).format('D')} al ${moment(endMonth).format(
          'D'
        )}`
      );
    } else {
      weekRanges.push(
        `Del ${moment(monthWeeks[i]).format('D')} al ${moment(monthWeeks[i])
          .add(6, 'days')
          .format('D')}`
      );
    }
  }
  return weekRanges;
}

/* This function writes the date on the subtitle of the card */
export const getDate = (type) => {
  let startDate;
  let endDate;
  let date;
  if (typeof type === 'number') {
    const month = type - 1;
    startDate = moment().month(month).startOf('month').format('D');
    endDate = moment()
      .month(month)
      .endOf('month')
      .format('D [de] MMMM [del] YYYY');
    date = `Del ${startDate} al ${endDate}`;
  } else if (type === 'all') {
    //startDate = moment().startOf('year').format('D');
    endDate = moment().endOf('year').format('MMMM [del] YYYY');
    date = `De enero a ${endDate.toLowerCase()}`;
  } else {
    startDate = moment().startOf(type === 'week' ? 'isoWeek' : type).format('D');
    endDate = moment().endOf(type === 'week' ? 'isoWeek' : type).format('D [de] MMMM [del] YYYY');
    if(type === 'week' && moment().startOf('isoWeek').month() !== moment().endOf('isoWeek').month()){
        startDate = moment().startOf('isoWeek').format('D [de] MMMM');
        date = `Del ${startDate} al ${endDate}`;
    }else{
      date = `Del ${startDate} al ${endDate}`;
      //console.log('mess', moment().startOf(type).month(), moment().endOf(type).month())
    }
  }

  return date;
};

function countByHour(hour, data) {
  let total =
    data &&
    data.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .isBetween(
          moment().hour(hour).startOf('hour'),
          moment().hour(hour).endOf('hour')
        )
    ).length;
  return total;
}

/* This function sums up the data, where date can be week or month */
export function countBy(date, data) {
  let total = [];
  const months = moment.months();

  if (months.includes(date)) {
    //console.log(months.includes(date), date)
    total =
      data &&
      data.filter((item) =>
        moment
          .unix(item.createdAt.seconds)
          .isBetween(
            moment().month(date).startOf('month'),
            moment().month(date).endOf('month')
          )
      ).length;
  } else if (date === 'all') {
    total =
      data &&
      data.filter((item) =>
        moment
          .unix(item.createdAt.seconds)
          .isBetween(moment().startOf('year'), moment().endOf('year'))
      ).length;
  } else if (typeof date === 'number') {
    const month = date - 1;
    total = data.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .isBetween(
          moment().month(month).startOf('month'),
          moment().month(month).endOf('month')
        )
    ).length;
  } else {
    total =
      data &&
      data.filter((item) =>
        moment
          .unix(item.createdAt.seconds)
          .isBetween(moment().startOf(date), moment().endOf(date))
      ).length;
  }
  return total;
}

const filterMonthly = (dataToFilter, month) => {
  //console.log('dataToFilter', dataToFilter);
  let endMonth =
    month === 'month'
      ? moment().endOf('month')
      : moment().month(month).endOf('month');
  const monthWeeks = getMonthWeeks(month);
  const dataFiltered = [];
  for (let i = 0; i < monthWeeks.length - 1; i++) {
    if (i == monthWeeks.length - 2) {
      dataFiltered.push(
        dataToFilter &&
          dataToFilter.filter((item) =>
            moment
              .unix(item.createdAt.seconds)
              .local()
              .isBetween(moment(monthWeeks[i]), moment(endMonth))
          ).length
      );
    } else {
      dataFiltered.push(
        dataToFilter &&
          dataToFilter.filter((item) =>
            moment
              .unix(item.createdAt.seconds)
              .local()
              .isBetween(
                moment(monthWeeks[i]),
                moment(monthWeeks[i]).add(6, 'days')
              )
          ).length
      );
    }
  }
  //console.log('dataFiltered', dataFiltered);
  return dataFiltered;
};

export const getChartData = (dataToFilter, chartName, period) => {
  //const dataByWeek = [4, 7, 9, 2, 5, 8, 7];

  /* Get actual week days  */
  const actualWeekDays =
    dataToFilter &&
    dataToFilter.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .utc()
        .isBetween(moment().startOf('week'), moment().endOf('week'))
    );

  /* Format dates of actualWeekDays */
  const formatedDays =
    actualWeekDays &&
    actualWeekDays.map((item) =>
      moment.unix(item.createdAt.seconds).format('D')
    );


  /* Count coincidences between weekDays array and formatedDays array */
  const sumDays = [];
  for (let day in weekDays2) {
    sumDays[day] =
      formatedDays &&
      formatedDays.filter((item) => weekDays2[day] === item).length;
  }
 

  let output;

  switch (chartName) {
    case 'messages':
      output = [['dia', 'Personas interesadas', { role: 'style' }]];

      if (period === 'week') {
        for (let item in weekDays) {
          output.push([
            weekDays[item],
            sumDays[item],
            `point { fill-color: #35b9b6; }`,
          ]);
        }
      } else if (typeof period === 'number') {
        const month = period - 1;
        const messages = filterMonthly(dataToFilter, month);
        const weekRanges = getWeekRanges(month);
        for (let item in weekRanges) {
          output.push([
            weekRanges[item],
            messages[item],
            `point { fill-color: #35b9b6; }`,
          ]);
        }
      } else if (period === 'all') {
        output = [['mes', 'Personas interesadas', { role: 'style' }]];
        const months = moment.months();

        for (let month in months) {
          //console.log('month', months[month])
          output.push([
            moment().month(months[month]).format('MMM'),
            countBy(months[month], dataToFilter),
            `point { fill-color: #35b9b6; }`,
          ]);
        }
      } else if (period === 'today') {
        output = [['hora', 'Personas interesadas', { role: 'style' }]];
        const defaultHrs = [0, 4, 8, 12, 16, 23];
        for (let hour in defaultHrs) {
          output.push([
            moment().hour(defaultHrs[hour]).minutes(0).format('LT'),
            countByHour(defaultHrs[hour], dataToFilter),
            `point { fill-color: #35b9b6; }`,
          ]);
        }
      }
      break;

    case 'opinions':
      const opinions = filterMonthly(dataToFilter, period);
      const weekRanges = getWeekRanges(period);
      output = [['dia', 'Opiniones']];
      for (let item in weekRanges) {
        output.push([weekRanges[item], opinions[item]]);
      }
      break;

    case 'views':
      output = [['dia', 'Visitas', { role: 'style' }]];
      if (period === 'week') {
        for (let item in weekDays) {
          if (item % 2 === 0) {
            output.push([weekDays[item], sumDays[item], 'color: #35b9b6']);
          } else {
            output.push([weekDays[item], sumDays[item], 'color: #106c9d']);
          }
        }
      } else if (typeof period === 'number') {
        const month = period - 1;
        const views = filterMonthly(dataToFilter, month);
        const weekRanges = getWeekRanges(month);
        for (let item in weekRanges) {
          if (item % 2 === 0) {
            output.push([weekRanges[item], views[item], 'color: #35b9b6']);
          } else {
            output.push([weekRanges[item], views[item], 'color: #106c9d']);
          }
        }
      } else if (period === 'all') {
        output = [['mes', 'Visitas', { role: 'style' }]];
        const months = moment.months();
        for (let month in months) {
          if (month % 2 === 0) {
            //console.log('mes par', month%2)
            output.push([
              moment().month(months[month]).format('MMM'),
              countBy(months[month], dataToFilter),
              'color: #35b9b6',
            ]);
            //console.log('visitas', output)
          } else {
            output.push([
              moment().month(months[month]).format('MMM'),
              countBy(months[month], dataToFilter),
              'color: #106c9d',
            ]);
          }
        }
      } else if (period === 'today') {
        output = [['hora', 'Visitas', { role: 'style' }]];
        const defaultHrs = [0, 4, 8, 12, 16, 23];
        for (let hour in defaultHrs) {
          if (hour % 2 === 0) {
            output.push([
              moment().hour(defaultHrs[hour]).minutes(0).format('LT'),
              countByHour(defaultHrs[hour], dataToFilter),
              'color: #35b9b6',
            ]);
          } else {
            output.push([
              moment().hour(defaultHrs[hour]).minutes(0).format('LT'),
              countByHour(defaultHrs[hour], dataToFilter),
              'color: #106c9d',
            ]);
          }
        }
      }

      break;
      default:
      break
  }

  return output;
};
